import { render, staticRenderFns } from "./XMLDocument.vue?vue&type=template&id=7d16dcf3&scoped=true"
import script from "./XMLDocument.vue?vue&type=script&lang=js"
export * from "./XMLDocument.vue?vue&type=script&lang=js"
import style0 from "./XMLDocument.vue?vue&type=style&index=0&id=7d16dcf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d16dcf3",
  null
  
)

export default component.exports